import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps2/pos'
});

export default {
	getCaptcha() {
		return httpClient.get('/captcha');
	},
	init() {
		return httpClient.get('/init');
	},
	sendBranchOffer(params) {
		return httpClient.post('/offer/branch', params);
	},
	download(type, fileToken) {
		return httpClient({
			url: '/pdf	',
			method: 'GET',
			responseType: 'blob',
			params: {
				type,
				fileToken
			}
		});
	},
	sendVmbOffer(params) {
		return httpClient.post('/offer/vmb', params);
	}
};
